import { render, staticRenderFns } from "./DonationForm.vue?vue&type=template&id=539e303c&"
import script from "./DonationForm.vue?vue&type=script&lang=ts&"
export * from "./DonationForm.vue?vue&type=script&lang=ts&"
import style0 from "./DonationForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('539e303c')) {
      api.createRecord('539e303c', component.options)
    } else {
      api.reload('539e303c', component.options)
    }
    module.hot.accept("./DonationForm.vue?vue&type=template&id=539e303c&", function () {
      api.rerender('539e303c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/donation/DonationForm.vue"
export default component.exports